import axios from 'axios';
import { API_URL } from "./utils/consts";

axios.defaults.baseURL = API_URL;
axios.defaults.headers.common['ngrok-skip-browser-warning'] = 'true';